<div [class.select--fill]="fill()" appFormControl class="select">
  <select
    (blur)="onBlur()"
    (focus)="onFocus()"
    [attr.required]="required"
    [formControl]="control"
    [id]="id"
    [name]="name"
    [ngClass]="{ 'select__input--empty': !value }"
    class="select__input"
  >
    <option [value]="!value ? value : undefined" disabled hidden>
      {{ placeholder() }}
    </option>
    @for (option of options(); track $index) {
      <option [value]="option.value">{{ option.label }}</option>
    }
  </select>

  @if (control.touched && control.enabled) {
    <app-validity-icon
      [valid]="control.valid"
      class="select__input-check-icon"
    />
  }

  @if (loading) {
    <app-form-loading-spinner class="select__loading" />
  } @else {
    <app-icon [name]="'chevron-down'" class="select__icon" />
  }
</div>
